import PostItem from '@/components/global/posts/item';
import PostsSidebar from '@/components/global/posts/sidebar';
import Guest from '@/layouts/guest';
import React, {LegacyRef} from 'react';
import { Container, Row } from 'react-bootstrap';
import Loader from "@/components/global/loader";

type Props = {
  onSortChange: (sort: string) => void,
  sort: string | undefined,
  postsRef: any,
  loading: boolean
}

const PostList: React.FC<IPostListResult & Props> = ({
  title, result_posts, post_type, onSortChange, sort, postsRef, loading
}) => {
  return (
    <Guest title={title}>
      <Container className="py-5">
        <Row>
          <div className="col-lg-3 mb-lg-0 mb-4">
            <PostsSidebar onSortChange={onSortChange} sort={sort} />
          </div>
          <div className="col-lg-9" ref={postsRef}>
            <Row>
              {result_posts.length || loading ? (
                  <>{result_posts.map((post, index) => (
                    <div key={post_type + post.id + Math.random()} className="col-lg-4 col-sm-6 mx-auto mb-4" style={{ maxWidth: '300px' }}>
                      <PostItem post={post} />
                    </div>
                  ))}
                    {loading ? (
                        <div className="container-fluid">
                          <Loader />
                        </div>
                    ) : ''}
                  </>
              ) : (
                  <div className="col-lg-12">
                      <h4 className="text-danger">موردی یافت نشد!</h4>
                  </div>
              )}
            </Row>
          </div>
        </Row>
      </Container>
    </Guest>
  );
}

export default PostList;
